// extracted by mini-css-extract-plugin
export default {"title":"Notifications_title__JUC99","more":"Notifications_more__9P4Co","details":"Notifications_details__gRsyo"};